import { toRaw } from 'vue'

/**
 * Turns Vue 3 reactive state into plain data.
 *
 * Vue 3 state is a Proxy, and the structured-clone algorithm behind IndexedDB
 * cannot copy one — persisting a mutation threw `DataCloneError: ... could not
 * be cloned`. Vue 2's reactive objects were plain and cloned fine, so this
 * appears only under Vue 3.
 *
 * `toRaw` unwraps one proxy but not the ones nested inside it, so the walk is
 * recursive. The result is plain data, which is all that was ever stored.
 */
export const unwrap = (value) => {
  const raw = toRaw(value)

  if (Array.isArray(raw)) return raw.map(unwrap)

  if (raw && 'object' === typeof raw && !(raw instanceof Date)) {
    return Object.fromEntries(Object.entries(raw).map(([k, v]) => [k, unwrap(v)]))
  }

  return raw
}
